import React from "react";
import { Row, Col, Input, Button, Divider, Avatar, Menu, message, Dropdown, Select } from "antd";
import { DownOutlined, CloseOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { addResouece } from "../../../../redux/editorSlice";
export default function ResourceList(props) {
  console.log("props.resourceList", props.resourceList);
  const menu = (
    <Menu>
      <Menu.Item
        key="resmenu_1"
        onClick={() => {
          props.addNewResource("Rest API");
        }}
      >
        Rest Api
      </Menu.Item>
      <Menu.Item
        key="resmenu_2"
        onClick={() => {
          props.addNewResource("Combined Resource");
        }}
      >
        Combined Resource
      </Menu.Item>
      {/* not configured yet - hidden until the connectors exist
      <Menu.Item key="resmenu_3">SQL database</Menu.Item>
      <Menu.Item key="resmenu_4">NoSql Database</Menu.Item> */}
    </Menu>
  );

  /* Changing the type rewrites THIS block. It used to call addNewResource, which added
     another resource - fine when the panel showed one resource, wrong now it is a list. */
  const handleSelectAPI = (API) => {
    if (props.onChangeResourceType) {
      props.onChangeResourceType(API);
      return;
    }
    props.addNewResource(API);
  };

  const { Option } = Select;
  //   return (
  //     <div style={{ padding: "8px" }}>
  //       <Row gutter={6}>
  //         <label>API Type</label>
  //         <Select
  //           value={props.selectedResource?.type}
  //           onChange={(value) => {
  //             handleSelectAPI(value);
  //           }}
  //         >
  //           <Option value="Rest API">REST API</Option>
  //           <Option value="Combined Resource">Combined Resource</Option>
  //           <Option value="Sql Database">SQL database</Option>
  //           <Option value="NoSql Database">NoSql Database</Option>
  //         </Select>
  //         <Col span={8}>
  //           {/* <Dropdown overlay={menu}>
  //             <div>
  //               <Button type="primary">
  //                 New
  //                 <DownOutlined />
  //               </Button>
  //             </div>
  //           </Dropdown> */}
  //         </Col>
  //       </Row>
  //       <Divider />
  //       <div>
  //         {props.resourceList.map((item, i) => {
  //           return (
  //             <div
  //               key={`res_q_${i}`}
  //               style={{
  //                 paddingTop: "8px",
  //                 paddingBottom: "8px",
  //                 borderBottom: "1px solid #ddd",
  //                 cursor: "pointer",
  //                 backgroundColor:
  //                   props.selectedResource && props.selectedResource.id === item.id ? "#efefff" : "#fafafa",
  //               }}
  //             >
  //               <div>
  //                 <div style={{ display: "flex", justifyContent: "space-between", padding: "4px" }}>
  //                   <div
  //                     style={{ display: "flex", justifyContent: "space-between", minWidth: "90%" }}
  //                     onClick={() => props.setSelected(item)}
  //                   >
  //                     <span>
  //                       {item.id}. {item.type ? item.type : "Combined Resource"}
  //                     </span>
  //                     <Avatar size="small">
  //                       {item["type"]
  //                         ? item["type"].split(/\s/).reduce((response, word) => (response += word.slice(0, 1)), "")
  //                         : "CR"}
  //                     </Avatar>
  //                   </div>
  //                   <div>
  //                     <Button
  //                       type="link"
  //                       danger
  //                       icon={<CloseOutlined style={{ fontSize: "12px" }} />}
  //                       onClick={() => props.removeResourceItem(item)}
  //                     ></Button>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           );
  //         })}
  //       </div>
  //     </div>
  //   );

  return (
    <div>
      <Row>
        <div className="rest-api-selector-field">
          <label>API Type</label>

          <Select
            placeholder="Select API Type"
            value={props.selectedResource?.type || undefined}
            onChange={(value) => {
              handleSelectAPI(value);
            }}
          >
            <Option value="Rest API">REST API</Option>
            <Option value="Combined Resource">Combined Resource</Option>
            {/* not configured yet - hidden until the connectors exist
            <Option value="Sql Database">SQL database</Option>
            <Option value="NoSql Database">NoSql Database</Option> */}
          </Select>
        </div>
      </Row>
    </div>
  );
}
